module.exports = __webpack_public_path__ + "img/zip-file.fde41165.png";